import { RiLoaderFill } from "react-icons/ri";

const LoaderFill = (props) => {
  const { size = "26", color = "#444444" } = props;

  return <RiLoaderFill size={size} color={color} />;
};

export default LoaderFill;
